import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'lg'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxWidths = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-80 overflow-y-auto" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby={title ? 'modal-title' : undefined} data-id="element-611">
      <div className={`relative w-full ${maxWidths[maxWidth]} bg-dark-surface border-2 border-dark-border rounded-industrial shadow-2xl my-8 max-h-[90vh] overflow-y-auto`} onClick={e => e.stopPropagation()} data-id="element-612">
        <div className="sticky top-0 z-10 flex items-center justify-between p-4 sm:p-6 bg-dark-surface border-b-2 border-dark-border" data-id="element-613">
          {title && <h2 id="modal-title" className="text-xl sm:text-2xl font-bold text-white" data-id="element-614">
              {title}
            </h2>}
          <button onClick={onClose} className="ml-auto p-2 text-white hover:text-brand-yellow transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial" aria-label="Zatvori modal" data-id="element-615">
            <XIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-616" />
          </button>
        </div>
        <div className="p-4 sm:p-6" data-id="element-617">{children}</div>
      </div>
    </div>;
}